<template>
    <div>
        <slot name="filter-field-range-options" v-bind="this"></slot>
    </div>
</template>

<script>
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

export default {
    name: 'FilterFieldRangeOptions',
    props: {
        filterItem: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            min: this.filterItem.min || 0,
            max: this.filterItem.max || 1000,
            currentValues: [
                this.filterItem.options[0].current || 0,
                this.filterItem.options[1].current || 1000
            ]
        }
    },
    mounted() {
        const sliderContainer = this.$el.querySelector('.slider-container');


        noUiSlider.create(sliderContainer, {
            start: this.currentValues,
            connect: true,
            range: {
                min: this.min,
                max: this.max
            },
            tooltips: true
        });

        sliderContainer.noUiSlider.on('change', (values) => {
            this.currentValues = values.map(v => parseFloat(v));
            this.$emit('update-option', {
                name: this.filterItem.name,
                currentMin: this.currentValues[0],
                currentMax: this.currentValues[1]
            });
        });

    }
};
</script>


